export const REQUEST_MASTER_COMMUNITY = "REQUEST_MASTER_COMMUNITY";
export const SET_MASTER_COMMUNITY = "SET_MASTER_COMMUNITY";
export const ERROR_GET_MASTER_COMMUNITY = "ERROR_GET_MASTER_COMMUNITY";

export const REQUEST_CREATE_MASTER_COMMUNITY = "REQUEST_CREATE_MASTER_COMMUNITY";
export const SUCCESS_CREATE_MASTER_COMMUNITY = "SUCCESS_CREATE_MASTER_COMMUNITY";
export const ERROR_CREATE_MASTER_COMMUNITY = "ERROR_CREATE_MASTER_COMMUNITY";

export const REQUEST_UPDATE_MASTER_COMMUNITY = "REQUEST_UPDATE_MASTER_COMMUNITY";
export const SUCCESS_UPDATE_MASTER_COMMUNITY = "SUCCESS_UPDATE_MASTER_COMMUNITY";
export const ERROR_UPDATE_MASTER_COMMUNITY = "ERROR_UPDATE_MASTER_COMMUNITY";

export const REQUEST_DELETE_MASTER_COMMUNITY = "REQUEST_DELETE_MASTER_COMMUNITY";
export const SUCCESS_DELETE_MASTER_COMMUNITY = "SUCCESS_DELETE_MASTER_COMMUNITY";
export const ERROR_DELETE_MASTER_COMMUNITY = "ERROR_DELETE_MASTER_COMMUNITY";

export const SET_MESSAGE_MASTER_COMMUNITY = "SET_MESSAGE_MASTER_COMMUNITY";